import React, { useContext, useEffect, useState } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";
import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import { useLoader } from "../../../utils/common";

const API_URL = "/admin/about-us/journey";

// preview of the picked file
const Preview = ({ file }) => {
  const [url, setUrl] = useState("");
  useEffect(() => {
    if (file && file.length) {
      const u = URL.createObjectURL(file[0]);
      setUrl(u);
      return () => URL.revokeObjectURL(u);
    }
    setUrl("");
  }, [file]);
  if (!url) return null;
  return <img src={url} alt="Preview" className="image-preview mt-2" style={{ maxWidth: 140, maxHeight: 120 }} />;
};

const AddJourney = ({ handleClose }) => {
  const { postData } = useContext(Context);
  const { withLoader } = useLoader();
  const [showModal, setShowModal] = useState({ code: 0, message: "" });

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({ defaultValues: { sort_order: 0 } });

  const onSubmit = async (data) => {
    try {
      const sendData = new FormData();
      sendData.append("year_label", data.year_label);
      sendData.append("label", data.label);
      sendData.append("description", data.description || "");
      sendData.append("sort_order", data.sort_order || 0);
      if (data.image && data.image.length) sendData.append("image", data.image[0]);

      const response = await withLoader(() => postData(API_URL, sendData));
      setShowModal({ code: response?.code, message: response?.message });
      setTimeout(() => {
        setShowModal({ code: 0, message: "" });
        if (response?.success) handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Modal
        show
        onHide={handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="edit-modal-holder"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Add Journey Step</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={(e) => e.preventDefault()} role="form">
            <Row className="justify-content-center">
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <Form.Label>Year / Tag</Form.Label>
                    <InputGroup className="d-block">
                      <Form.Control
                        type="text"
                        placeholder="e.g. 1995, 7 years, 1 lakh+"
                        maxLength={40}
                        className={classNames("w-100", { "is-invalid": errors?.year_label })}
                        {...register("year_label", {
                          required: "Year / tag is required",
                          maxLength: { value: 40, message: "Maximum 40 characters" },
                        })}
                      />
                    </InputGroup>
                    {errors.year_label && <span className="text-danger">{errors.year_label.message}</span>}
                  </Form.Group>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <Form.Label>Display Order</Form.Label>
                    <InputGroup className="d-block">
                      <Form.Control
                        type="number"
                        min={0}
                        placeholder="1 = first (top of the lens)"
                        className="w-100"
                        {...register("sort_order")}
                      />
                    </InputGroup>
                    <small className="text-muted">Steps go clockwise from the top, in this order.</small>
                  </Form.Group>
                </div>
              </Col>

              <Col md={12}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <Form.Label>Name (short label shown around the lens)</Form.Label>
                    <InputGroup className="d-block">
                      <Form.Control
                        type="text"
                        placeholder="e.g. Pune, 2006"
                        maxLength={160}
                        className={classNames("w-100", { "is-invalid": errors?.label })}
                        {...register("label", {
                          required: "Name is required",
                          maxLength: { value: 160, message: "Maximum 160 characters" },
                        })}
                      />
                    </InputGroup>
                    <div className="text-end">
                      <small>160 characters limit</small>
                    </div>
                    {errors.label && <span className="text-danger">{errors.label.message}</span>}
                  </Form.Group>
                </div>
              </Col>

              <Col md={12}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <Form.Label>Information (shown in the card when the step is active)</Form.Label>
                    <InputGroup className="d-block">
                      <Form.Control
                        as="textarea"
                        rows={5}
                        placeholder="Information"
                        className={classNames("w-100", { "is-invalid": errors?.description })}
                        {...register("description", { required: "Information is required" })}
                      />
                    </InputGroup>
                    {errors.description && <span className="text-danger">{errors.description.message}</span>}
                  </Form.Group>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <Form.Label>Image</Form.Label>
                    <InputGroup className="d-block">
                      <Form.Control
                        type="file"
                        accept="image/*"
                        className={classNames("w-100", { "is-invalid": errors?.image })}
                        {...register("image", { required: "Image is required" })}
                      />
                    </InputGroup>
                    {errors.image && <span className="text-danger">{errors.image.message}</span>}
                  </Form.Group>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Preview file={watch("image")} />
                </div>
              </Col>

              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton name={"Cancel"} handleClose={handleClose} />
                  </Link>
                  <SaveButton name={"Save"} handleSubmit={handleSubmit(onSubmit)} />
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave message={showModal.message} showErrorModal={showModal.code ? true : false} />
    </>
  );
};

export default AddJourney;